export default function About() {
  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left Content */}
          <div className="bg-[#0A1628] p-8 sm:p-12 lg:p-16 rounded-3xl">
            <div className="mb-6">
              <span className="text-[#FF6B35] text-sm font-bold uppercase tracking-wider">
                Who We Are
              </span>
            </div>

            <h2 className="text-4xl sm:text-5xl md:text-6xl font-black text-white mb-6 sm:mb-8 leading-tight">
              Obstacle Training for Every Level
            </h2>

            <p className="text-white/80 text-base sm:text-lg leading-relaxed mb-8 sm:mb-12">
              Tri County Ninja is more than just a gym—it's a community where athletes of all ages and abilities come together to push their limits, build confidence, and have fun conquering obstacles.
            </p>

            {/* Value Points */}
            <div className="space-y-8">
              <div className="flex items-start">
                <div className="w-10 h-10 rounded-full bg-[#FF6B35] flex items-center justify-center flex-shrink-0">
                  <i className="ri-trophy-line text-white text-xl"></i>
                </div>
                <div className="ml-5">
                  <p className="text-white text-lg">
                    Fun and challenging obstacle-based training that keeps you engaged
                  </p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="w-10 h-10 rounded-full bg-[#FF6B35] flex items-center justify-center flex-shrink-0">
                  <i className="ri-heart-pulse-line text-white text-xl"></i>
                </div>
                <div className="ml-5">
                  <p className="text-white text-lg">
                    Build strength, agility, coordination, and confidence
                  </p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="w-10 h-10 rounded-full bg-[#FF6B35] flex items-center justify-center flex-shrink-0">
                  <i className="ri-team-line text-white text-xl"></i>
                </div>
                <div className="ml-5">
                  <p className="text-white text-lg">
                    Welcoming environment for beginners through advanced athletes
                  </p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="w-10 h-10 rounded-full bg-[#FF6B35] flex items-center justify-center flex-shrink-0">
                  <i className="ri-home-heart-line text-white text-xl"></i>
                </div>
                <div className="ml-5">
                  <p className="text-white text-lg">
                    Supportive family-friendly community that celebrates every achievement
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Right Image */}
          <div className="relative h-full min-h-[300px] sm:min-h-[500px] lg:min-h-[600px] rounded-3xl overflow-hidden">
            <img
              src="https://storage.readdy-site.link/project_files/8c606bec-a1c4-4337-82da-c52a0844d7ac/5c028ba9-6cc0-40a3-b60a-0658359cf068_IMG_20260415_000420.jpg?v=0e97e0e02e2e76bb9d71849cbd530b00"
              alt="Ninja Training Community"
              className="w-full h-full object-cover object-center"
            />
            <div className="absolute inset-0 bg-[#FF6B35]/20"></div>
          </div>
        </div>
      </div>
    </section>
  );
}